package sticker;

import fomantic.Calendar;
import fomantic.Dropdown;
import sticker.Ecchymodel;
import coconut.ui.View;
using tink.CoreApi;
import sticker.StickerComps;
import sticker.StillLifeModel;

class StillLife extends coconut.ui.View{


    @:attr
    public var sessionNum:Int;
    @:attr
    public var date:Date;

    @:attr
    public var hashtag:String;

  

    @:attr
    public var background:String= @byDefault "";

   

    @:attr
    public var nb_participants:Int;

    @:attr
    public var prixSession:Int;

    @:attr
    public var sessionType:StillLifeType = @byDefault classique;

    @:attr
    public var dateString:String;

    @:attr
    public var setNum:Int->Promise<Noise>;
    @:attr
    public var setHash:String->Promise<Noise>;
    @:attr
    public var setSessionNum:Int->Promise<Noise>;
    @:attr
    public var setDate:Date->Promise<Noise>;

    @:attr
    public var setSessionType:StillLifeType->Promise<Noise>;


    public function render()
        <div class='sticker' style='background-image:url(${background};'>
        <h1> Session Still Morte Nature Life  nº<EcritoNumInput text={sessionNum} choose={n->setSessionNum(n)}/> </h1>
        <Dater data={date} dataString={dateString} onAct={e->setDate(e)} />
        <h5>session <InlineDropdown data={StillLifeType.toValues()} choose={n->setSessionType(n)} dataString={sessionType} /> 
    
        </h5> .
       <p> Inscriptions ouvertes avec le code :</p>
        <h1> #<EcritoLineInput text={hashtag} choose={n->setHash(n)}/></h1>
        <p>
        <span>participants :
        
        <EcritoNumInput text={nb_participants} choose={n->setNum(n)}/> 
        </span>
       <span>
        ={prixSession}€
        </span>
        </p>

        </div>
        ;


    
}




